<template>

    <div>
        <div class="container">

            <div class="card card-daily-challenge" style="height: calc(100vh - 190px);">
                <div class="card-header">
                    <div class="card-title">{{ $t('menu_item_achievements') }}</div>
                </div>
                <div class="card-body" style="padding-bottom: 50px;">
                    <div>{{ $t('complete_all_the_achievements_to_get_rewards') }}</div>

                    <div class="nano" style="height: 100%;">
                        <div class="nano-content">
                            <div class="missions">
                                <template v-for="(achievement, index) in achievements">
                                    <achievement-item :achievement="achievement"/>
                                </template>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            
            <get-reward-modal/>

        </div>
    </div>

</template>

<script>
import axios from "axios";
import {getAchievements} from "../../models/achievement";
import AchievementItem from "./AchievementItem";
import GetRewardModal from '../modal/GetRewardModal.vue';

export default {
  name: "Achievement",
  components: {AchievementItem, GetRewardModal},
  title: 'Missions',

  data() {
    return {
      achievements: [],
    };
  },

  computed: {
    user_info() {
      return this.$store.state.user_info
    }
  },

  created() {
    this.$store.commit('setMenuActive', 'achievement');

    this.fetch();
  },

  methods: {
    async fetch() {
      const that = this;

      await axios.all([
        getAchievements(),
      ]).then(axios.spread((response) => {
        that.isLoading = false;

        if (response.data.code != 0) {
          return;
        }
        
        
        that.achievements = response.data.results.achieve || [];
        console.log('achi:', that.achievements);

        that.$nextTick(function() {
            // var initNanoScroller = function() {
            //     if ($('.nano').length > 0) {
            //         $(".nano").nanoScroller();
            //     }
            // }
            // initNanoScroller();
        })             
      }));
    },

  }
}
</script>

<style scoped>
   /* .container{
        width: 940px;
        padding: 0;
    } */
</style>
